import { render } from "./NewCandidacyForm.vue?vue&type=template&id=6af9a508&scoped=true"
import script from "./NewCandidacyForm.vue?vue&type=script&lang=js"
export * from "./NewCandidacyForm.vue?vue&type=script&lang=js"

import "./NewCandidacyForm.vue?vue&type=style&index=0&id=6af9a508&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af9a508"]])

export default __exports__